import { setApiClientHeader } from '../apiClient';

export function updateAuthTokens({ csrf }: { csrf?: string; jwt?: string }): void {
  if (csrf) {
    setApiClientHeader('X-CSRF-TOKEN', csrf);
  }
}
